import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Microsoft365LicenseSettings } from '../models/generated/ziroModels';

@Injectable()
export class Microsoft365LicenseSettingsResource {
  protected http = inject(HttpClient);

  get(tenantId: number): Observable<Microsoft365LicenseSettings> {
    return this.http.get<Microsoft365LicenseSettings>(
      `/services/microsoft/admin/tenants/${tenantId}/365-license-settings`,
    );
  }

  put(tenantId: number, data: Microsoft365LicenseSettings): Observable<void> {
    return this.http.put<void>(`/services/microsoft/admin/tenants/${tenantId}/365-license-settings`, data);
  }
}
